// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__1wrmg","modal-content":"Modal_modal-content__1EOSc","show":"Modal_show__3O0m2","modal_heading":"Modal_modal_heading__3_NY1"};